import React from 'react'
import { Formik } from 'formik'
import { WireTransferValues } from './Types'
import { wireTransferSchema } from './wireTransferValidations'
import { RetirementConstraintsResponse } from '@Types'
import WireTransferForm from '../../components/WireTransferForm'
import { WireTransferPageProps } from './WireTransfers'

export interface WireTransfersProps extends WireTransferPageProps {
  constraintData: RetirementConstraintsResponse
}

const WireFormikWrapper = ({
  account,
  amountAvailable,
  countryList,
  constraintData,
  ...restProps
}: WireTransfersProps) => {
  const defaultValues = {
    fromAccount: account.accountNumber,
    amountAvailable,
    isIra: constraintData?.retirementAccount
  }

  const formikConfig = {
    initialValues: wireTransferSchema(
      countryList,
      defaultValues,
      constraintData?.distributionConstraints?.validDistributionReasons,
      constraintData?.distributionConstraints?.totalDistributionAllowed
    ).cast({}),
    onSubmit: (values: WireTransferValues) => {},
    validationSchema: () =>
      wireTransferSchema(
        countryList,
        defaultValues,
        constraintData?.distributionConstraints?.validDistributionReasons,
        constraintData?.distributionConstraints?.totalDistributionAllowed
      ),
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true
  }
  return (
    <Formik {...formikConfig}>
      <WireTransferForm
        account={account}
        amountAvailable={amountAvailable}
        countryList={countryList}
        constraintData={constraintData}
        {...restProps}
      />
    </Formik>
  )
}

export default WireFormikWrapper
